import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { history } from '../sharedHistory';
import SMART_SEARCH from 'smart-search';
import SMART_SEARCH_pckg from '../../node_modules/smart-search/package.json';

import authentication from './authenticationReducer';
import config from './configReducer';
import language from './languageReducer'
import props from "./propReducer";
import pages from "./pagesReducer";

const SMART_SEARCH_reduxPerInstance = SMART_SEARCH_pckg['app-framework'] && SMART_SEARCH_pckg['app-framework'].reduxPerInstance;

const identityReducer = (state = null, action) => state;

const systemReducers = {
  router: connectRouter(history),
  authentication,
  pages,
  language,
  config,
  props
};

const singleReducer = (reduxPerInstance, reducer) => {
  if(!reducer) return null;
  if(reduxPerInstance) return null;
  return reducer;
};


const perInstanceReducer = (pckg, instanceId, reduxPerInstance, reducer) => {
  if (!reducer) return null;
  if (!reduxPerInstance) return null;
  const changedInstanceId = instanceId.replace(/-/g, '_');
  return (state, action) => {
    if (action.instanceId) {
      if (
        Array.isArray(action.instanceId) &&
        action.instanceId.includes(changedInstanceId)
      ) {
        return reducer(state, action);
      } else if (action.instanceId === changedInstanceId) {
        return reducer(state, action);
      } else {
        return state;
      }
    } else return reducer(state, action, action.instanceId, changedInstanceId);
  };
};


const singleReducersInit = {
  'smart-search': singleReducer(SMART_SEARCH_reduxPerInstance, SMART_SEARCH.reducer),
};

const userReducersPerInstanceInit = {
  'smart-search': SMART_SEARCH.reducer && SMART_SEARCH_reduxPerInstance && combineReducers(Object.fromEntries(Object.entries({
    '6964e499a734c00d0dff8a55': perInstanceReducer('smart-search', '6964e499a734c00d0dff8a55', SMART_SEARCH_pckg['app-framework'], SMART_SEARCH.reducer),
  }).filter(pair => pair[1]))),
};

const userReducersSingle = Object.fromEntries(Object.entries(singleReducersInit).filter(pair => pair[1]));
const userReducersPerInstance = Object.fromEntries(Object.entries(userReducersPerInstanceInit).filter(pair => pair[1]));

export default combineReducers({
  ...systemReducers,
  ...userReducersSingle,
  ...userReducersPerInstance,
});
